<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="bootstrap-wrapper">
          <div class="container-fluid">
            <div class="row mx-auto">
              <div
                class="modal-container elevation-1 radius-20"
                :class="classes"
              >
                <div class="modal-header text-center row">
                  <div class="col-12">
                    <button
                      class="modal-default-button elevation-1 radius p-2"
                      @click="$emit('close')"
                    >
                      <i class="fas fa-times text-primary"></i>
                    </button>
                    <span class="text-barlow-condensed subtitle text-dark h4">
                      {{ title }}
                    </span>
                  </div>
                </div>

                <div class="modal-body px-4 custom-scroll">
                  <slot name="body">
                    default body
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: {
    title: {},
    classes: {
      default: "col-md-10 col-lg-10",
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  max-height: calc(90vh - 40px);
  overflow-y: auto;
}

.modal-default-button {
  outline: none;
  float: right;
  width: 40px;
  height: 40px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
